import { Container } from "@mui/material";
import { requester } from "App";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import KakaoLogin from "react-kakao-login";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import adultImg from "resources/img/login/adult.png";
import kakao from "resources/login/kakao_login_medium_wide.png";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";

import MobileHomePageSignIn from "./MobileHomePageSignIn";

function HomePageLogin(props) {
    const inputs = useRef([]);
    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const [role, setRole] = useState('MEMBER'); // role 상태 초기화
    const { userName } = useContext(AuthContext);
    const { isMobile } = useContext(BrowserDetectContext);
    const navigate = useNavigate();

    // useEffect(() => {
    //     localStorage.removeItem("token");
    // }, []);

    // role 변경 핸들러
    const handleRoleChange = (event) => {
        setRole(event.target.value); // 선택된 role로 상태 업데이트
    };

    const signIn = () => {
        let data = { storeId: "root", userName: "", password: "", role: role };

        data.userName = inputs.current[0].getValue();
        data.password = inputs.current[1].getValue();

        requester.userSignIn(data, (result) => {

            if (result.code === -1) {
                if (result.message === "Invalid userName") {
                    //존자하지 않는 아이디
                    toast.error(t("noUserName"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                } else if (result.message === "Invalid credentials") {
                    //비번틀림
                    toast.error(t("noPassword"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            } else if (result.code === 0) {
                let tokenData = result.data.token;
                dispatch(AuthReducer.actions.setToken(tokenData));
                navigate(`/ws/${id}/homepage`);
                // modal.current.close();
                // // navigate("/");
            }
        });
    }

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }

    const onClick = () => {
        let data = { data: "" }
        requester.kakaosocialTest(data, (result) => {
            
        })
    }

    const SocialKakao = () => {

        const kakaoClientId = '16a90518df394cb54916c4aa918a1a58'
        const kakaoOnSuccess = async (data) => {
            
            const idToken = data.response.access_token;  // 엑세스 토큰 백엔드로 전달
            const kakaoId = data.profile.id;
            let tokenData = { token: idToken, kakaoId: kakaoId }
            // requester.kakaoLogin(tokenData, (result) => {
            //     
            // })
            requester.kakaosocialTest(tokenData, (result) => {
                
                if (result.code === -1) {
                    
                } else if (result.code === 0) {
                    let token = result.data.token;
                    dispatch(AuthReducer.actions.setToken(token));
                }
            })

        }
        const kakaoOnFailure = (error) => {
            
        };

        return (
            <KakaoLogin
                token={kakaoClientId}
                onSuccess={kakaoOnSuccess}
                onFail={kakaoOnFailure}
            />
        )
    }
    const SocialKakao2 = () => {
        const Rest_api_key = 'e38748253f56640a5bf87d23233254b5' //REST API KEY
        const redirect_uri = 'http://localhost:3000/ws/root/memberSignIn' //Redirect URI
        // oauth 요청 URL
        const kakaoURL = `https://kauth.kakao.com/oauth/authorize?client_id=${Rest_api_key}&redirect_uri=${redirect_uri}&response_type=code`
        const handleLogin = () => {
            window.location.href = kakaoURL
        }
        return (
            <>
                <img src={kakao} onClick={handleLogin} />
            </>
        )
    }
    const signUp = () => {
        navigate("/signUp");
    }

    const onShippingPolicyClick = () => {
        navigate(`/ws/${id}/shippingPolicy`)
    }
    const onPrivacyPolicyClick = () => {
        navigate(`/ws/${id}/privacyPolicy`)
    }
    const onTermsOfUseClick = () => {
        navigate(`/ws/${id}/termsOfUse`)
    }

    return (
        <>
            {
                isMobile
                    ?
                    <MobileHomePageSignIn footer />
                    :
                    <Container maxWidth={1200}>

                        <VerticalFlex gap={20}>
                            <FlexChild>
                                <P size={40} font={"gmarketSansBold"} color={"black"}>로그인</P>
                            </FlexChild>
                            {/* <FlexChild>
                                <HorizontalFlex gap={30}>
                                    <FlexChild width={"20%"} >
                                        <P>역할 : </P>
                                    </FlexChild>
                                    <FlexChild>

                                        <select value={role} onChange={handleRoleChange}>
                                            <option value="MEMBER">멤버</option>
                                            <option value="ADMIN">관리자</option>
                                            <option value="VENDOR">점주</option>
                                        </select>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild> */}
                            <FlexChild>
                                <HorizontalFlex gap={30}>
                                    <FlexChild width={"20%"} >
                                        <P>아이디 : </P>
                                    </FlexChild>
                                    <FlexChild>
                                        <InputText onEnterPress={signIn} ref={el => (inputs.current[0] = el)} placeHolder={"아이디"} />
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex gap={30}>
                                    <FlexChild width={"20%"} >
                                        <P>비밀번호 : </P>
                                    </FlexChild>
                                    <FlexChild>
                                        <InputPassword onEnterPress={signIn} ref={el => (inputs.current[1] = el)} signIn placeHolder={"비밀번호"} />
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild>
                                        <HorizontalFlex gap={15}>
                                            <FlexChild justifyContent={"flex-end"}>
                                                <CustomButton text={"로그인"} style={btnStyle} onClick={signIn} />
                                            </FlexChild>
                                            <FlexChild>
                                                <CustomButton text={"회원가입"} onClick={signUp} />
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                    <FlexChild>
                                        {/* <SocialKakao /> */}
                                        {/* <button onClick={onClick} >click</button> */}
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild>
                                <img src={adultImg} />
                            </FlexChild>
                            {
                                props.footer
                                &&
                                <FlexChild width={"100%"} height={"10vh"} overflow={"hidden"} backgroundColor={"white"}>
                                    <VerticalFlex>
                                        <FlexChild height={"1vh"}>
                                        </FlexChild>
                                        <FlexChild>
                                            <Center textAlign={"left"}>
                                                {/* <P size={80} color={"white"}>하단배너</P> */}
                                                <P>Copyright 2021.TechtonicSoft Corp. all rights reserved</P>
                                                <P>사업자등록번호 729-86-02229  |  대표: 정환욱</P>
                                                <P>대전광역시 서구 관저중로95번길 68, 1층 | 고객센터 070-4943-2597</P>
                                            </Center>
                                        </FlexChild>
                                        <FlexChild width={"50%"}>
                                            <HorizontalFlex gap={20}>
                                                <FlexChild justifyContent={"flex-end"}>
                                                    <P cursor onClick={onTermsOfUseClick}>이용약관</P>
                                                </FlexChild>
                                                <FlexChild width={"max-content"}>
                                                    <P>|</P>
                                                </FlexChild>
                                                <FlexChild width={"max-content"}>
                                                    <P cursor onClick={onPrivacyPolicyClick}>개인정보정책</P>
                                                </FlexChild>
                                                <FlexChild width={"max-content"}>
                                                    <P>|</P>
                                                </FlexChild>
                                                <FlexChild justifyContent={"flex-start"}>
                                                    <P cursor onClick={onShippingPolicyClick}>배송정책</P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                    </VerticalFlex>
                                    {/* <img src={banner} alt="" style={{ width: "100%", transform: "translateY(-30%)" }} /> */}
                                </FlexChild>
                            }

                        </VerticalFlex>
                    </Container>
            }
        </>

    );
}

export default HomePageLogin;